import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/propietarios",
    label: "Propietarios",
  },
  {
    path: "",
    label: "Visualización",
    isActive: true,
  },
];

function MostrarPropietario() {
  return (
    <Page
      title="Visualización de Propietario"
      description="Información detallada de propietario."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default MostrarPropietario;
